// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"4827":"572e0935","4858":"60c4a891","7702":"60c4a891","9764":"a7ebab04"}[chunkId] + ".chunk.css";
};